import Vue from 'vue'
import Router from 'vue-router'
import MainPage from '@/components/MainPage'
import Apps from '@/components/Apps'
import About from '@/components/About'
import Terms from '@/components/Terms'
import Privacy from '@/components/Privacy'

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
    
Vue.use(ElementUI);

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'MainPage',
      component: MainPage
    },
    {
      path: '/apps',
      name: 'Apps',
      component: Apps
    },
    {
      path: '/about',
      name: 'About',
      component: About
    },
    {
      path: '/terms',
      name: 'Terms',
      component: Terms
    },
    {
      path: '/privacy',
      name: 'privacy',
      component: Privacy
    },

  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js